<template>
  <v-container fluid>
    <v-data-table
      :headers="studentHeaders"
      :items="filteredStudents"
      :items-per-page="30"
      :search="studentSearch"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title
            >My Students (Count:{{ filteredStudents.length }}
            <v-btn v-if="filteredStudents.length > 0" icon @click="download">
              <v-icon small>mdi-view-list</v-icon> </v-btn
            >)</v-toolbar-title
          >

          <v-divider class="mx-4" inset vertical />

          <v-dialog v-model="dialog" max-width="600px" scrollable>
            <v-card>
              <v-card-title>{{ menuTitle }}</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="identity.first_name"
                        label="First Name"
                        autocomplete="off"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="identity.middle_name"
                        label="Middle Name"
                        autocomplete="off"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="identity.last_name"
                        label="Last Name"
                        autocomplete="off"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="student.student_id"
                        label="Student ID"
                        autocomplete="off"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :value="identity.gender_code == 'F' ? 'Female' : 'Male'"
                        label="Gender"
                        autocomplete="off"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :value="
                          new Date(
                            selectedStudentDetails.school_entry_date
                          ).toLocaleDateString()
                        "
                        label="Entry Date"
                        prepend-icon="mdi-calendar"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :value="student.home_language"
                        label="Home Language"
                        :readonly="true"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="dialog = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="scheduleDialog" max-width="800">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" small v-on="on"> </v-icon>
            </template>
            <v-card>
              <v-card-title>
                <v-toolbar dark color="primary"
                  >{{ user_name }}<v-spacer />
                  <v-btn icon @click="scheduleDialog = false">
                    <v-icon dark>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
              </v-card-title>
              <student-schedule :user_id="user_id" :user_name="user_name" />
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="accountDialog"
            :retain-focus="false"
            max-width="300"
            scrollable
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" small v-on="on"> </v-icon>
            </template>
            <v-card>
              <v-card-title>
                {{ selectedStudentDetails.full_name }}
              </v-card-title>
              <v-spacer />
              <v-card-subtitle>
                Email:
                <v-text-field v-model="account.email" :readonly="true" />
              </v-card-subtitle>
              <v-card-subtitle>
                Account Password:
                <v-text-field v-model="account.spass" :readonly="true" />
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="accountDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="disciplineDialog" max-width="900px" scrollable>
            <v-card>
              <v-card-title>{{ menuTitle }}</v-card-title>
              <v-container fluid>
                <v-dialog v-model="adminActionsDialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"></v-icon>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-toolbar dark>
                        Actions taken for: {{ menuTitle }}
                        <v-spacer />
                        <v-btn icon @click="adminActionsDialog = false">
                          <v-icon>mdi-close</v-icon></v-btn
                        >
                      </v-toolbar>
                    </v-card-title>
                    <v-card-text>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th>Action</th>
                              <th>Action Taken By</th>
                              <th>Date</th>
                              <th>Notes</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="action in actions_taken"
                              :key="action.id"
                            >
                              <td>{{ action.actionTaken }}</td>
                              <td>{{ action.actionTakenBy }}</td>
                              <td>
                                {{ new Date(action.date).toLocaleDateString() }}
                              </td>
                              <td>{{ action.notes }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <v-data-table
                  :headers="disciplineHeaders"
                  :items="referrals"
                  :items-per-page="20"
                  :search="disciplineSearch"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                  show-expand
                  class="elevation-1"
                >
                  <template v-slot:[`item.incident_time`]="{ item }">
                    {{ new Date(item.incident_time).toLocaleDateString() }}
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      Details: {{ item.explanations }}
                    </td>
                  </template>
                  <template v-slot:top>
                    <v-spacer />
                    <v-col cols="12" lg="4" md="4" sm="">
                      <v-text-field
                        v-model="disciplineSearch"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                      />
                    </v-col>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-chip
                      @click="viewAdminAction(item)"
                      v-if="item.actions_taken.length > 0"
                      color="green lighten-2"
                    >
                      Actions Taken
                    </v-chip>
                    <v-chip v-else>No actions yet </v-chip>
                  </template>
                </v-data-table>
              </v-container>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="disciplineDialog = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-if="student.grade_level && student.grade_level.name > 4"
            v-model="studentGradeBookDialog"
            max-width="900px"
            scrollable
          >
            <v-card rounded="md" height="100%">
              <v-card-title>{{ menuTitle }}</v-card-title>
              <student-gradebook-all :student="student"></student-gradebook-all>
            </v-card>
          </v-dialog>
          <v-dialog
            v-else
            v-model="studentGradeBookDialog"
            max-width="900px"
            scrollable
          >
            <v-card rounded="md" height="100%">
              <v-card-title>
                {{ menuTitle }}
                <v-divider />
                <v-btn @click="printReportCard">Print</v-btn>
              </v-card-title>
              <v-container fluid>
                <v-card
                  class="mt-5"
                  flat
                  tile
                  v-for="section in sections"
                  :key="section.info.id"
                >
                  <v-toolbar
                    dark
                    color="secondary"
                    v-if="section.average != 'N/A'"
                  >
                    <v-toolbar-title>{{ section.info.name }}</v-toolbar-title>
                  </v-toolbar>
                  <student-gradebook-table-k4
                    :grades="grades"
                    :assessments="section.assessments"
                    :average="section.average + ''"
                  >
                  </student-gradebook-table-k4>
                </v-card>
              </v-container>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="studentGradeBookDialog = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="studentAttendanceRecordsDialog"
            max-width="900px"
            scrollable
          >
            <v-card>
              <v-card-title>{{ menuTitle }}</v-card-title>
              <v-container fluid>
                <v-data-table
                  :headers="attendanceHeaders"
                  :items="attendanceRecords"
                  :items-per-page="10"
                  :search="attendanceSearch"
                  class="elevation-1"
                >
                  <template>
                    <v-spacer />
                    <v-row>
                      <v-col cols="6" lg="4" md="4" sm="">
                        <v-text-field
                          v-model="attendanceSearch"
                          append-icon="mdi-magnify"
                          label="Search"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-container>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="studentAttendanceRecordsDialog = false"
                  >Cancel</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer />
          <v-text-field
            v-model="studentSearch"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
          <v-select
            class="mb-n5 ml-5"
            v-model="filterGrades"
            :items="gradeNames"
            label="Filter Grade"
            clearable
            dense
            small-chips
            multiple
          >
          </v-select>
          <v-divider class="mx-4" inset vertical />
        </v-toolbar>
      </template>
      <template v-slot:[`item.view`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewAccount(item)"
            >
              mdi-format-list-checkbox
            </v-icon>
          </template>
          <span>Account Details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewSchedule(item)"
            >
              mdi-calendar-clock
            </v-icon>
          </template>
          <span>Schedule</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewStudentDetails(item)"
            >
              mdi-eye-settings
            </v-icon>
          </template>
          <span>Details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewStudentDisciplineRecords(item)"
            >
              mdi-shield-account-variant
            </v-icon>
          </template>
          <span>Discipline Records</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewStudentGradeBook(item)"
            >
              mdi-book-open
            </v-icon>
          </template>
          <span>Grade Books</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewStudentAttendanceRecords(item)"
            >
              mdi-human-male-board
            </v-icon>
          </template>
          <span>Attendance Records</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              small
              v-bind="attrs"
              v-on="on"
              @click="viewStudentCallLog(item)"
            >
              mdi-phone
            </v-icon>
          </template>
          <span>Call Log</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.enrollment_grade_level_section`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              color="primary"
              dark
              small
              v-bind="attrs"
              v-on="on"
              v-if="item.enrollment_grade_level_section"
            >
              {{ item.enrollment_grade_level_section }}
            </v-chip>
          </template>
        </v-menu>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" timeout="2000">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import StudentSchedule from "./StudentSchedule";
import StudentGradebookTableK4 from "./StudentGradebookTableK4";
import StudentGradebookAll from "../components/StudentGradebookAll";

export default {
  components: {
    StudentSchedule,
    StudentGradebookAll,
    StudentGradebookTableK4,
  },
  props: {
    students: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    snackbar: false,
    snackbarMessage: null,
    scheduleDialog: false,
    startDateMenu: false,
    disciplineDialog: false,
    adminActionsDialog: false,
    studentGradeBookDialog: false,
    studentAttendanceRecordsDialog: false,
    singleExpand: true,
    studentSearch: "",
    disciplineSearch: null,
    attendanceSearch: null,
    dialog: false,
    menuTitle: null,
    selectedStudentDetails: {},
    identity: {},
    student: {},
    user_id: null,
    user_name: null,
    filterGrades: [],
    referrals: [],
    expanded: [],
    actions_taken: [],
    grades: [],
    sections: [],
    assessments: [],
    attendanceRecords: [],
    account: {},
    accountDialog: false,
    studentHeaders: [
      { text: "Student ID", value: "student_id" },
      { text: "Full Name", value: "full_name_2" },
      { text: "Grade Level", value: "grade_level_name" },
      {
        text: "Grade Section",
        value: "enrollment_grade_level_section",
        width: "150px",
      },
      { text: "View", value: "view" },
      { text: "Action", value: "action" },
    ],
    disciplineHeaders: [
      { text: "", value: "data-table-expand" },
      { text: "Incident", value: "incident" },
      { text: "Location", value: "incident_location" },
      { text: "Teacher", value: "teacher_name" },
      { text: "Date/Time", value: "incident_time" },
      { text: "Admin Actions", value: "actions", sortable: false },
    ],
    attendanceHeaders: [
      { text: "Date", value: "date" },
      { text: "Result", value: "result" },
    ],
  }),
  computed: {
    filteredStudents() {
      if (this.filterGrades.length < 1) return this.students;
      return this.students.filter(
        (s) => this.filterGrades.indexOf(s.grade_level_name) > -1
      );
    },
    gradeNames() {
      var flags = [],
        output = [],
        l = this.students.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[this.students[i].grade_level_name]) continue;
        flags[this.students[i].grade_level_name] = true;
        output.push(this.students[i].grade_level_name);
      }
      return output;
    },
  },
  methods: {
    csv(array) {
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    download() {
      let csv = this.csv(
        this.filteredStudents.map((s) => {
          return {
            student_id: s.student_id,
            full_name: s.full_name_2,
            grade_level_name: s.grade_level_name,
            enrollment_grade_level_section: s.enrollment_grade_level_section,
          };
        })
      );
      let fileLink = document.createElement("a");
      fileLink.href = window.URL.createObjectURL(
        new Blob([csv], { type: "text/csv;charset=utf-8;" })
      );
      fileLink.setAttribute("download", "students.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    printReportCard() {
      window.open(
        process.env.VUE_APP_API_URL +
          `/students/print-grading-report?students=[${this.student.user_id}]`,
        "_blank"
      );
    },
    viewSchedule(item) {
      this.user_id = item.user_id;
      this.user_name = item.full_name_2;
      this.scheduleDialog = true;
    },

    viewAccount(student) {
      this.$sisApi("get", `students/account/${student.user_id}`)
        .then((response) => {
          this.account = response.data;
          this.selectedStudentDetails = { ...student };
          this.accountDialog = true;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.snackbarMessage = error.response;
            this.snackbar = true;
          }
        });
    },

    viewStudentDetails(student) {
      this.$sisApi("get", `students/student/${student.user_id}`)
        .then((response) => {
          this.menuTitle = "Student Details";
          this.identity = response.data.identity;
          this.student = response.data.student;
          this.contacts = response.data.contacts;
          this.teams = response.data.teams;
          this.selectedStudentDetails = { ...student };
          this.dialog = true;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.snackbarMessage = error.response;
            this.snackbar = true;
          }
        });
    },

    viewStudentCallLog(item) {
      window.open(
        "https://communications.buffsci.org/call-log/list?student=" +
          item.user_id,
        "_blank"
      );
    },

    viewStudentDisciplineRecords(student) {
      this.disciplineDialog = true;
      this.getDisciplineRefs(student);
    },

    viewAdminAction(item) {
      this.adminActionsDialog = true;
      this.actions_taken = [...item.actions_taken];
    },

    getDisciplineRefs(student) {
      this.$sisApi("get", `my-schedule/discipline/student/${student.user_id}`)
        .then((response) => {
          this.referrals = response.data;
          this.menuTitle = student.full_name;
        })
        .catch((error) => {
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        });
    },

    viewStudentGradeBook(student) {
      this.student = student;
      this.studentGradeBookDialog = true;
      this.menuTitle = student.full_name;
    },

    viewStudentAttendanceRecords(student) {
      this.attendanceRecords = [];
      this.menuTitle = "";
      this.$sisApi("get", `my-schedule/students-attendance/${student.user_id}`)
        .then((response) => {
          this.studentAttendanceRecordsDialog = true;
          this.attendanceRecords = response.data;
          this.menuTitle =
            student.full_name +
            " - " +
            student.grade_level_name +
            " - Section: " +
            student.enrollment_grade_level_section;
        })
        .catch((error) => {
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        });
    },
  },
  mounted() {},
};
</script>